export const PARTNERS = {
  PORTAL_WAREHOUSING: {
    name: 'Portal Warehousing',
    hash: 'UG9ydGFsIFdhcmVob3VzaW5n',
    url: '/auth/register#UG9ydGFsIFdhcmVob3VzaW5n',
    logo: '/media/gori/referral-logos/portal_warehousing_logo.png',
  },
  ROMAN_TEST_COMPANY: {
    name: 'Roman Test Company',
    hash: 'Um9tYW4gVGVzdCBDb21wYW55',
    url: '/auth/register#Um9tYW4gVGVzdCBDb21wYW55',
    logo: '/media/gori/referral-logos/rtd2_logo.png',
  },
}

export const VALID_PARTNER_HASHES: string[] = Object.values(PARTNERS).map((p) => p.hash)
